var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
import * as React from 'react';
import { FormHelper } from 'react-form-helper';
import { getValue } from 'react-form-helper/dist/src/helpers';
import IconButton from 'react-toolbox/lib/button/IconButton';
import Input from 'react-toolbox/lib/input';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { removeIn, updateIn } from 'redux-decorated';
import { Row } from 'styled-material';
import { Menu } from './menu';
import { Table, TableCell, TableHeader, TableRow } from './table';
export var ToolboxInput = function ToolboxInput(_a) {
    var _ = _a.required,
        props = __rest(_a, ["required"]);
    return React.createElement(Input, Object.assign({}, props));
};
var CellInput = function CellInput(props) {
    return React.createElement(TableCell, null, React.createElement(ToolboxInput, Object.assign({}, props)));
};
var enhance = compose(lifecycle({
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (nextProps.edit == null) {
            if (nextProps.mapFields) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = nextProps.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var value = _step.value;

                        var fields = nextProps.mapFields(nextProps.editFields, value);
                        if (fields.some(function (field) {
                            return field.validationError;
                        })) {
                            nextProps.setEdit(value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }
}));
/**
 * Component for displaying a list of items, which handles editing and removal.
 *
 * ##### Example
 * ```
 * const enhance = compose(
 *   withState('user', 'setUser', [{username: 'test', password: 'test'}]),
 *   withState('editUser', 'setEditUser', null),
 * )
 *
 * export const EditUser = enhance(({editUser, setEditUser, user, setUser}) =>
 *   <EditList
 *     value={user}
 *     labels={[
 *       {
 *         label: 'Username',
 *         path: ['username']
 *       },
 *       {
 *         label: 'Password',
 *         path: ['password']
 *       },
 *     ]}
 *     onChange={setUser}
 *     editFields={[
 *       {
 *         path: ['username'],
 *         required: true,
 *       },
 *       {
 *         path: ['password'],
 *         required: true,
 *       }
 *     ]}
 *     edit={editUser}
 *     setEdit={setEditUser}
 *   />
 * ```
 */
export var EditList = enhance(function (_ref) {
    var list = _ref.value,
        _onChange = _ref.onChange,
        labels = _ref.labels,
        editFields = _ref.editFields,
        mapFields = _ref.mapFields,
        edit = _ref.edit,
        setEdit = _ref.setEdit,
        _ref$editCaption = _ref.editCaption,
        editCaption = _ref$editCaption === undefined ? 'Edit' : _ref$editCaption,
        _ref$deleteCaption = _ref.deleteCaption,
        deleteCaption = _ref$deleteCaption === undefined ? 'Delete' : _ref$deleteCaption,
        errorOnTouched = _ref.errorOnTouched;
    return React.createElement(Table, null, React.createElement(TableRow, null, list.length > 0 && labels.map(function (label, i) {
        return React.createElement(TableHeader, { key: i }, label.label);
    })), list.map(function (value, i) {
        return editFields && edit === value ? React.createElement(FormHelper, { key: i, errorOnTouched: errorOnTouched, formComponent: TableRow, inputComponent: CellInput, value: value, onSave: function onSave(updatedObject) {
                _onChange(updateIn(i, updatedObject, list));
                setEdit(updatedObject);
            }, onChange: function onChange(updatedObject) {
                _onChange(updateIn(i, updatedObject, list));
                setEdit(updatedObject);
            }, fields: mapFields ? mapFields(editFields, value) : editFields, buttonComponent: function buttonComponent(_ref2) {
                var disabled = _ref2.disabled;
                return React.createElement(TableCell, null, React.createElement(Row, { horizontal: 'flex-end' }, React.createElement(IconButton, { icon: 'check', disabled: disabled, onClick: function onClick() {
                        return setEdit(null);
                    } }), React.createElement(IconButton, { icon: 'delete', onClick: function onClick() {
                        setEdit(null);
                        _onChange(removeIn(i, list));
                    } })));
            }, saveButton: 'Save' }) : React.createElement(TableRow, { key: i }, labels.map(function (label, i) {
            var labelValue = getValue(label.path, value);
            return React.createElement(TableCell, { style: { width: '100%' }, key: i }, React.createElement("span", null, labelValue));
        }), React.createElement(TableCell, null, React.createElement(Menu, { position: 'topRight', menuRipple: true, items: [{ value: 'edit', icon: 'edit', caption: editCaption, onClick: function onClick() {
                    setEdit(value);
                }
            }, { value: 'delete', icon: 'delete', caption: deleteCaption, onClick: function onClick() {
                    _onChange(removeIn(i, list));
                }
            }] })));
    }));
});
//# sourceMappingURL=edit-list.js.map
